import { Workbook } from 'exceljs';

import { DataGrid } from 'devextreme-react';
import { exportDataGrid } from 'devextreme/excel_exporter';
import saveAs from 'file-saver';

const addMaterialUtils = (gridCell, excelCell) => {
  if (gridCell.rowType === 'data' && typeof gridCell.value === 'number') {
    excelCell.value = `${excelCell.value} ${gridCell.data.unitName}`;
  }
};

export const onExporting = (e: any, date: string) => {
  const workbook = new Workbook();
  const worksheet = workbook.addWorksheet('1');

  exportDataGrid({
    component: e.component,
    worksheet,
    autoFilterEnabled: true,
    topLeftCell: { row: 3, column: 1 },
    customizeCell: ({ gridCell, excelCell }) => {
      addMaterialUtils(gridCell, excelCell);
    },
  })
    .then(() => {
      // header
      const headerRow1 = worksheet.getRow(1);

      worksheet.mergeCells(1, 1, 1, 8);
      worksheet.mergeCells(2, 1, 2, 8);

      headerRow1.getCell(1).value = `Списание материалов за: ${date}`;
      headerRow1.getCell(1).font = { bold: true };
      headerRow1.getCell(1).alignment = { horizontal: 'center' };
    })
    .then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'DataGrid.xlsx');
      });
    });
  e.cancel = true;
};

const setAlternatingRowsBackground = (gridCell, excelCell) => {
  if (gridCell.rowType === 'header' || gridCell.rowType === 'data') {
    if (excelCell.fullAddress.row % 2 === 0) {
      excelCell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'D3D3D3' },
        bgColor: { argb: 'D3D3D3' },
      };
    }
  }
};

export const exportGrids = (
  balanceDataGrid: DataGrid['instance'] | undefined,
  detailDataGrid: DataGrid['instance'] | undefined,
) => {
  const workbook = new Workbook();
  const priceSheet = workbook.addWorksheet('Остатки инерта');
  const ratingSheet = workbook.addWorksheet('Итоги');

  priceSheet.getRow(2).getCell(2).value = 'Остатки инерта';
  priceSheet.getRow(2).getCell(2).font = { bold: true, size: 16, underline: 'double' };

  ratingSheet.getRow(2).getCell(2).value = 'Итоги';
  ratingSheet.getRow(2).getCell(2).font = { bold: true, size: 16, underline: 'double' };

  exportDataGrid({
    worksheet: priceSheet,
    component: balanceDataGrid,
    topLeftCell: { row: 4, column: 2 },
    customizeCell: ({ gridCell, excelCell }) => {
      setAlternatingRowsBackground(gridCell, excelCell);
      addMaterialUtils(gridCell, excelCell);
    },
  })
    .then(() =>
      exportDataGrid({
        worksheet: ratingSheet,
        component: detailDataGrid,
        topLeftCell: { row: 4, column: 2 },
        customizeCell: ({ gridCell, excelCell }) => {
          setAlternatingRowsBackground(gridCell, excelCell);
          addMaterialUtils(gridCell, excelCell);
        },
      }),
    )
    .then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Отчет.xlsx');
      });
    });
};
